module.exports = __webpack_public_path__ + "static/media/zamzam2.4fb06ebc.jpeg";